// extracted by mini-css-extract-plugin
export default {"row":"styles_row__rSpDw"};